// eslint-disable-next-line import/no-extraneous-dependencies
import Swal from 'sweetalert2';

const customSwal = Swal.mixin({
  toast: true,
  position: 'top',
  iconColor: 'white',
  customClass: {
    popup: 'colored-toast',
  },
  showConfirmButton: false,
  showCloseButton: true,
  padding: '30px 20px',
});

/*
 * 에러 토스트.
 * 파라미터로 출력할 메시지를 받는다.
 * 사용예시: errorToast('내용을 출력하겠습니다.')
 */
export const errorToast = (text) => {
  customSwal.fire({
    icon: 'error',
    title: 'Error',
    text,
  });
};

/*
 * 성공 토스트.
 * 파라미터로 출력할 메시지를 받는다.
 * 사용예시: successToast('내용을 출력하겠습니다.')
 */
export const successToast = (text) => {
  customSwal.fire({
    icon: 'success',
    title: 'Success',
    text,
  });
};

/*
 * 주의 토스트.
 * 파라미터로 출력할 메시지를 받는다.
 * 사용예시: warningToast('내용을 출력하겠습니다.')
 */
export const warningToast = (text) => {
  customSwal.fire({
    icon: 'warning',
    title: 'Warning',
    text,
  });
};

/*
 * 정보 토스트.
 * 파라미터로 출력할 메시지를 받는다.
 * 사용예시: infoToast('내용을 출력하겠습니다.')
 */
export const infoToast = (text) => {
  customSwal.fire({
    icon: 'info',
    title: 'Info',
    text,
  });
};

/*
 * 확인 토스트
 * 파라미터로 출력할 메시지를 받고, 예/아니오 버튼을 출력한다.
 * 예, 아니오 버튼을 클릭하면 콜백함수를 실행한다.
 * 사용예시: confirmToast('내용을 출력하겠습니다.', () => { console.log('예 버튼 클릭') })
 */
export const confirmToast = (text, callback) => {
  customSwal.fire({
    icon: 'warning',
    title: 'Warning',
    text,
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: '예',
    cancelButtonText: '아니오',
  }).then((result) => {
    if (result.isConfirmed) {
      callback();
    }
  });
};

/*
 * 선택 다이얼로그
 * 두 가지 선택지를 제공하는 다이얼로그입니다.
 * @param {string} text - 표시할 메시지
 * @param {string} option1Text - 첫 번째 선택지 텍스트
 * @param {string} option2Text - 두 번째 선택지 텍스트
 * @param {Function} onOption1 - 첫 번째 선택지 클릭 시 콜백
 * @param {Function} onOption2 - 두 번째 선택지 클릭 시 콜백
 * 사용예시: choiceDialog('메시지', '옵션1', '옵션2', () => {}, () => {})
 */
export const choiceDialog = (text, option1Text, option2Text, onOption1, onOption2) => {
  Swal.fire({
    icon: 'warning',
    title: '선택',
    text,
    showCancelButton: true,
    showDenyButton: true,
    confirmButtonText: option1Text,
    denyButtonText: option2Text,
    cancelButtonText: '취소',
  }).then((result) => {
    if (result.isConfirmed) {
      onOption1();
    } else if (result.isDenied) {
      onOption2();
    }
  });
};
